import { WordFragment } from "../create";
import { applyHtmlSpecialChars } from "../util/";
import { CreateElement } from "./element";
import { OptionsParagraph } from "./paragraph";
import { CreateRpr, OptionsRpr } from "./rpr";

interface OptionsText extends OptionsRpr {
    /** Text content */
    text: string;
}

/**
 * Create text
 */
class CreateText extends CreateElement {
    /**
     * Element options
     */
    protected options: OptionsText | WordFragment;

    /**
     * Constructor
     *
     * @param options - Text contents and options
     * @param optionsParagraph - Options paragraph
     */
    constructor(
        options: OptionsText | WordFragment,
        optionsParagraph: OptionsParagraph = {}
    ) {
        super();

        if (options instanceof WordFragment) {
            // WordFragment content
            this.options = options;
        } else {
            // OptionsText content
            this.options = options;

            // apply paragraph rPr styles
            this.options = this.mergeParagraphRprStyles(
                this.options,
                optionsParagraph
            );
        }
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        let contents = "";

        if (this.options instanceof WordFragment) {
            // WordFragment content
            contents = this.options
                .getDocxContent()
                .getInlineXmlContents(this.options.toString());

            // keep external contents from the WordFragment to be added into the document when the WordFragment is added
            this.mergeExternalDependencies(this.options);
        } else {
            // text content
            contents = "<w:r>";

            // rPr styles
            const rPrElement = new CreateRpr(this.options);
            contents += rPrElement.create();

            // text content
            contents +=
                '<w:t xml:space="preserve">' +
                applyHtmlSpecialChars(this.options.text) +
                "</w:t>";

            contents += "</w:r>";
        }

        return contents;
    }
}

export { CreateText, OptionsText };
